import React from 'react';

import format from 'date-fns/format';
import { observer } from 'mobx-react';

import localeStore from 'src/stores/LocaleStore';

export const LocalizedDate = observer(
  ({ date, dateFormat = 'PP' }: { date: Date; dateFormat?: string }) => {
    const options = {};

    if (localeStore.datesLocale) {
      // @ts-expect-error - localeStore.datesLocale is a valid locale
      options.locale = localeStore.datesLocale;
    }
    return <span className="localized-date">{format(date, dateFormat || 'PP', options)}</span>;
  }
);
